import { deleteWithAuth, postWithAuth } from "@/lib/api-helpers";
import type { CustomEmoji } from "@/types/workspace";

/** True when an API helper returned its error envelope. */
function isApiError(res: unknown): res is { isError: true; message?: string } {
  return typeof res === "object" && res !== null && "isError" in res && (res as { isError?: unknown }).isError === true;
}

/** Create a workspace custom emoji. Any member may do this. */
export async function createCustomEmoji(workspaceId: string, name: string, imageUrl: string): Promise<CustomEmoji> {
  const res = await postWithAuth<{ emoji: CustomEmoji }>("/api/work-space/settings/emoji/create-emoji", {
    workspaceId,
    name,
    imageUrl,
  });
  if (isApiError(res)) throw new Error(res.message || "Failed to create custom emoji");
  return res.emoji;
}

/** Rename a custom emoji. Allowed for the creator, workspace owner, or admin. */
export async function updateCustomEmoji(workspaceId: string, emojiId: string, name: string): Promise<CustomEmoji> {
  const res = await postWithAuth<{ emoji: CustomEmoji }>("/api/work-space/settings/emoji/update-emoji", {
    workspaceId,
    emojiId,
    name,
  });
  if (isApiError(res)) throw new Error(res.message || "Failed to rename custom emoji");
  return res.emoji;
}

/** Delete a custom emoji. Allowed for the creator, workspace owner, or admin. */
export async function deleteCustomEmoji(workspaceId: string, emojiId: string): Promise<void> {
  const res = await deleteWithAuth<{ emojiId: string }>("/api/work-space/settings/emoji/delete-emoji", {
    body: JSON.stringify({ workspaceId, emojiId }),
  });
  if (isApiError(res)) throw new Error(res.message || "Failed to delete custom emoji");
}
